// extracted by mini-css-extract-plugin
export var avatar = "_rr-3";
export var avatarContainer = "_rr-2";
export var avatarSpacer = "_rr-5";
export var avatarSpacerContainer = "_rr-4";
export var avatarStackContainer = "_rr-1";
export var bubble = "_rr-0";
export var remainderBubble = "_rr-6";